import { Badge } from '@frontend/shadcn/components/ui/badge';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { ChevronRight, InfoIcon, Tag, Trophy } from 'lucide-react';
import React from 'react';

export const RefreshRewardOfferBoost = (): JSX.Element => {
  return (
    <Card className="border-grey-2 w-full rounded-2xl border border-solid">
      <CardContent className="p-4">
        <div className="flex w-full items-start gap-4">
          <div className="flex h-[54px] w-[54px] flex-shrink-0 items-center justify-center rounded-2xl bg-[#4A9DFF]">
            <Tag className="h-6 w-6 text-white" />
          </div>
          <div className="flex flex-1 flex-col gap-2">
            <div className="w-full">
              <div className="flex w-full items-center justify-between">
                <h3 className="text-grey-6 font-medium">
                  Discount worth $100 on all products
                </h3>
                <div className="flex items-center gap-2.5">
                  <Badge className="flex items-center gap-1 rounded-lg bg-[#4CAF50] px-2 py-0.5 text-white">
                    <Trophy className="h-3 w-3" />
                    <span className="whitespace-nowrap text-xs">Claimed</span>
                  </Badge>
                  <ChevronRight className="text-grey-3 h-5 w-5" />
                </div>
              </div>
              <div className="flex flex-col">
                <div className="flex items-center gap-1">
                  <span className="text-grey-5 whitespace-nowrap text-xs">
                    Reward on 50th conversion
                  </span>
                  <InfoIcon className="text-grey-3 h-3 w-3" />
                </div>
                <div className="flex items-start gap-1">
                  <span className="text-grey-5 whitespace-nowrap text-xs">
                    Ends Nov 5, 2025
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
export default RefreshRewardOfferBoost;
